import { atom } from "@mongez/react-atom";

export const contactUsAtom = atom({
  key: "successRequest",
  default: false,
});
